import type { PageLoad } from './$types';
import type { PageData } from '$lib/metadataTypes/MetaTypes';

export const load: PageLoad = async ({ parent }): Promise<PageData> => {
  const { site, category } = await parent(); // parent() = CategoryData

  return {
    site,
    category,
    page: {
			title: "Editor Customization",
description: "Learn how to customize Freon’s projectional editor using generated box providers, custom projections, and custom actions, including how to register and configure them.",
tags: [ "editor", "customization", "projections", "actions", "box providers", "Freon", "DSL development", "TypeScript"] ,
modifiedTime: "2025-11-07T19:02:04.740Z",
publishedTime: "2025-11-07T17:20:18.626Z"
    }
  };
};